var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationMapPin = function SvgLocationMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 47,
    fill: "none",
    viewBox: "0 0 44 47"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.5 30h27v6h-18L6 41z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40A05B",
    d: "M4.5 0h30v30h-17l-13 13z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 43.5,
    height: 23,
    x: 0,
    y: 24,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1932_1442",
    stdDeviation: 3
  })))));
};
export default SvgLocationMapPin;